import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PartSizeService } from 'pages/standard-setup/part-sizes/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PartSizeService, DialogService, EventAggregator)
export class Statuses {
    constructor(partSizeService, dialogService, ea) {
        this.ea = ea;
        this.partSizeService = partSizeService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('part-sizes:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (partSize) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.partSizeService.delete(partSize.id);
                this.grid.refresh();
                toastr.success('Part size was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.partSizeService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.partSizeService.editor, model: { id: data.id } });
    };
}